import { render, staticRenderFns } from "./ContentItemLabel.vue?vue&type=template&id=8b124264&scoped=true&"
import script from "./ContentItemLabel.vue?vue&type=script&lang=js&"
export * from "./ContentItemLabel.vue?vue&type=script&lang=js&"
import style0 from "./ContentItemLabel.vue?vue&type=style&index=0&id=8b124264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b124264",
  null
  
)

export default component.exports